import React, { useState, useEffect } from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import './AppSettingsModal.scss';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import { useDispatchLogoutAction } from 'login/store/dispatcher';
import AppSettingsEditor from './AppSettingsEditor';
import SettingsModal from './SettingsModal';
import { useSelectAppMode } from 'app/store/general/selectors';
import { AppMode } from 'app/store/general/AppMode';
import classNames from 'classnames';

export default function AppSettingsModal() {
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();
    const dispatchLogout = useDispatchLogoutAction();

    const appMode = useSelectAppMode();
    const showLogout = appMode === AppMode.STANDALONE;

    const [openClassName, setOpenClassName] = useState<string>();

    const [editedSettings, setEditedSettings] =
        useState<AppSettingsState>(appSettings);
    useEffect(() => {
        setEditedSettings(appSettings);
    }, [appSettings]);

    const onOpen = () => setOpenClassName('modal-open');

    const onSave = () => {
        dispatchUpdateAppSettings(editedSettings);
        setOpenClassName(undefined);
    };

    const onCancel = () => {
        setEditedSettings(appSettings);
        setOpenClassName(undefined);
    };

    const onLogout = () => {
        dispatchLogout();
    };

    const onAppSettingsChanged = (partial: Partial<AppSettingsState>) => {
        setEditedSettings({
            ...editedSettings,
            ...partial,
        });
    };

    return (
        <SettingsModal
            className={classNames(
                'AppSettingsModal',
                showLogout && 'show-logout'
            )}
            trigger={
                <div
                    className={classNames(
                        openClassName,
                        'AppSettingsModal-trigger'
                    )}
                >
                    <Icon name="cog" />
                    Settings
                </div>
            }
            headerText="User Settings"
            saveText="Apply & Close"
            onCancel={onCancel}
            onOpen={onOpen}
            onSave={onSave}
        >
            <AppSettingsEditor
                appSettings={editedSettings}
                onAppSettingsChanged={onAppSettingsChanged}
            />

            {showLogout && (
                <div className="group logout">
                    <div className="link-text" onClick={onLogout}>
                        Logout
                    </div>
                </div>
            )}
        </SettingsModal>
    );
}
